export function formatPeso(value: number | string, opts?: { decimals?: number }): string {
  const n = typeof value === "string" ? Number(value) : value;
  if (!isFinite(n)) return "₱0.00";
  const d = opts?.decimals ?? 2;
  return (
    "₱" +
    n.toLocaleString("en-PH", {
      minimumFractionDigits: d,
      maximumFractionDigits: d,
    })
  );
}

export function formatCompactPeso(value: number): string {
  if (Math.abs(value) >= 1_000_000) return `₱${(value / 1_000_000).toFixed(2)}M`;
  if (Math.abs(value) >= 1_000) return `₱${(value / 1_000).toFixed(1)}K`;
  return formatPeso(value);
}

export function formatDate(iso: string | null | undefined): string {
  if (!iso) return "—";
  const d = new Date(iso + (iso.length === 10 ? "T00:00:00" : ""));
  return d.toLocaleDateString("en-PH", { month: "short", day: "numeric", year: "numeric" });
}

export function toISODate(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function monthLabel(isoMonth: string): string {
  const [y, m] = isoMonth.split("-").map(Number);
  return new Date(y, m - 1, 1).toLocaleDateString("en-PH", { month: "long", year: "numeric" });
}

export function cn(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(" ");
}
